// @ts-check

class BmModelShowcase extends HTMLElement {
  /** @type {NodeListOf<HTMLElement>} */
  images;
  /** @type {NodeListOf<HTMLButtonElement>} */
  thumbs;
  /** @type {HTMLButtonElement | null} */
  prev;
  /** @type {HTMLButtonElement | null} */
  next;
  currentIndex = 0;

  connectedCallback() {
    this.images = this.querySelectorAll('.bmc__image');
    this.thumbs = this.querySelectorAll('.bmc__thumb');
    this.prev = this.querySelector('.bmc__nav--prev');
    this.next = this.querySelector('.bmc__nav--next');

    if (!this.images.length) return;

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (e) => {
        const target = e.currentTarget;
        if (!(target instanceof HTMLElement)) return;
        const idx = Number(target.dataset.index);
        if (Number.isInteger(idx)) this.goTo(idx);
      });
    });

    this.prev?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    this.next?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
      else if (e.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
    });
  }

  /**
   * @param {number} idx
   */
  goTo(idx) {
    const total = this.images.length;
    if (total === 0) return;
    this.currentIndex = ((idx % total) + total) % total;
    this.images.forEach((img, i) => {
      img.classList.toggle('is-active', i === this.currentIndex);
    });
    this.thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === this.currentIndex);
    });
  }
}

if (!customElements.get('bm-model-showcase')) {
  customElements.define('bm-model-showcase', BmModelShowcase);
}
